import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"
script.__scopeId = "data-v-5af69798"

export default script